import {
  Component,
  EventEmitter,
  input,
  InputSignal,
  Output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FileSizePipe } from '@shared/pipes';

@Component({
    selector: 'app-file-uploader-item',
    templateUrl: './file-uploader-item.component.html',
    styleUrls: ['./file-uploader-item.component.scss'],
    imports: [MatIcon, FileSizePipe]
})
export class FileUploaderItemComponent {
  file = input.required<File>();

  @Output()
  remove: EventEmitter<File> = new EventEmitter();

  removeItem(file: File): void {
    this.remove.emit(file);
  }
}
